module.exports = {
  methods: {
    $_jsonToCsv (filename, jsonData, labelsConf, separator) {
      if (!jsonData.length) {
        this.$_handleError('Error: Data are empty')
        return
      }
      const csvLabels = this.$_createCsvLabels(labelsConf, separator)
      const csvData = this.$_createCsvContent(jsonData, labelsConf, separator)
      if (csvLabels === 'error' || csvData === 'error') {
        this.$_handleError('Error: An error occured while parsing the data.')
        return
      }
      const content = csvLabels + csvData
      this.$_downloadCsv(content, filename)
    },
    $_createCsvLabelsConf (arr) {
      const conf = {}

      arr.map(function (m, i) {
        conf[m] = { title: m }
      })

      return conf
    },
    $_createCsvLabels (labels, separator) {
      let row = ''
      let c = ''

      try {
        Object.keys(labels).map(function (m, i) {
          row += `"${labels[m].title}"` + separator
        })

        row = row.slice(0, -1)

        c += row + '\r\n'
        return c
      } catch (err) {
        c = 'error'
      }
    },
    $_createCsvContent (arr, labels, separator) {
      let row = ''
      let c = ''
      let type = ''

      try {
        arr.map(function (m, i) {
          row = ''

          Object.keys(labels).map(function (k, s) {
            type = typeof m[k]
            if (type === 'number' || type === 'float') {
              row += m[k] + separator
            } else {
              row += `"${m[k].replace(/"/g, '""')}"` + separator
            }
          })

          row = row.slice(0, -1)

          c += row + '\r\n'
        })
        return c
      } catch (err) {
        c = 'error'
      }
    },
    $_downloadCsv (content, filename) {
      const bom = new Uint8Array([0xef, 0xbb, 0xbf])
      const blob = new Blob([bom, content], { type: 'text/csv' })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, filename)
      } else {
        const url = (window.URL || window.webkitURL).createObjectURL(blob)
        const download = document.createElement('a')
        download.href = url
        download.download = filename
        download.click()
        window.URL.revokeObjectURL(url)
        window.webkitURL.revokeObjectURL(url)
      }
    },
    $_getDateString () {
      const d = new Date()
      const year = String(d.getFullYear())
      const month = this.zeroPadding(d.getMonth() + 1)
      const day = this.zeroPadding(d.getDate())
      const hour = this.zeroPadding(d.getHours())
      const min = this.zeroPadding(d.getMinutes())
      const sec = this.zeroPadding(d.getSeconds())
      return year + month + day + hour + min + sec
    },
    zeroPadding (num) {
      const res = ('00' + num).slice(-2)
      return res
    },
    $_handleError (msg) {
      throw msg
    }
  }
}
